import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-personal-objective",
  "use": "icon-personal-objective-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-personal-objective\">\n<rect width=\"16\" height=\"16\" rx=\"2\" fill=\"#4C9AFF\" />\n<path d=\"M5.44141 4.48438V12H6.78516V9.51562H8.30599C9.82682 9.51562 10.8945 8.5 10.8945 7C10.8945 5.5 9.85807 4.48438 8.36328 4.48438H5.44141ZM6.78516 5.58333H8.00911C8.97266 5.58333 9.52995 6.09896 9.52995 7C9.52995 7.91146 8.96745 8.43229 8.00391 8.43229H6.78516V5.58333Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol